/** imported components

  * LearningCenterView for ==> it's a view component.

**/


import React from 'react';
import {LearningCenterView} from './LearningCenterView';

export const LearningCenterController = (props) => {
    return (
        <>
            <LearningCenterView {...props} />
        </>
    );
}

